// CreatorLevelExample
import React from 'react';
import styles from './CreatorLevelExample.module.sass';
import { CreatorLevelExampleType } from 'types/addCredits';
import cn from 'classnames';
import ContentPreviewModal from 'components/common/ContentPreviewModal';
import Carousel from 'components/common/Carousel';

export interface CreatorLevelExampleProps extends CreatorLevelExampleType {
  isVisible: boolean;
}

const CreatorLevelExample: React.FC<CreatorLevelExampleProps> = ({
  descriptions,
  contentExamples,
  isVisible,
}) => {
  return (
    <div
      className={cn(styles.creatorLevelExample, {
        [styles.hide]: !isVisible,
      })}
    >
      <div className={styles.descriptions}>
        {descriptions.map((description, index) => (
          <p
            className={cn(styles.description, 'VG5000')}
            key={`description-${index}`}
          >
            {description}
          </p>
        ))}
      </div>
      <Carousel
        className={styles.contentExamples}
        slides={contentExamples.map((exampleUrl) => (
          <ContentPreviewModal
            previewClassName={styles.previewExample}
            key={exampleUrl}
            type={/(mov)|(mp4)/gi.test(exampleUrl) ? 'video' : 'image'}
            contentPath={exampleUrl}
            alt={exampleUrl}
          />
        ))}
      />
    </div>
  );
};

export default CreatorLevelExample;
